import React, { Component } from 'react';

import { DefinitionField } from 'components/common/fields/DefinitionField';
import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

export default class RequirementsForCandidate extends Component {
    isEmptyRequirements(project) {
        return !(
            project.experience || project.education || project.foreignLanguage
            || project.sex || project.age || project.typeofexperience
        );
    }

    render() {
        const { project } = this.props;

        if (this.isEmptyRequirements(project)) {
            return null;
        }

        return (
            <div>
                <DefinitionHeader translate="project.requirements_for_candidate" iconType="list-ul" />
                <div className="panel-view">
                    <DefinitionField translate="project.headers.requirements" text={ project.experience } textClassName="newline text-justify text-pre-space" />
                    <DefinitionField translate="project.education" text={ project.education } textClassName="newline text-justify" />
                    <DefinitionField translate="project.languages" text={ project.foreignLanguage } textClassName="newline text-justify text-pre-space" />
                    <DefinitionField translate="project.sex" text={ project.sex } />
                    <DefinitionField translate="project.age" text={ project.age } />
                    <DefinitionField translate="project.typeofexperience" text={ project.typeofexperience } />
                </div>
            </div>
        );
    }
}
